<script setup lang="ts">
import CenterModal from "~/components/Common/Modals/CenterModal.vue";
import { useSessionsStore } from "~/store/sessions/sessions-store";
import AppButton from "~/components/Common/Buttons/AppButton.vue";

/**
 * Shared by the external and the internal training modals, so the reload is left to the caller:
 * each one knows its own store and how it resolved the training it is editing.
 */
const emit = defineEmits(["hide", "deleted"]);

const props = defineProps({
  sessionId: {
    type: String,
  },
});

const sessionsStore = useSessionsStore();

function cancel() {
  emit("hide");
}

async function confirm() {
  if (!props.sessionId) return;

  await sessionsStore.cancelSession(props.sessionId);
  emit("deleted");
  emit("hide");
}
</script>

<template>
  <CenterModal :style="{ 'max-width': '488px', width: '100%' }">
    <template #body>
      <div class="grid p-[24px] gap-[24px] body_regular">
        <div class="flex flex-col gap-2">
          <h4 class="heading_4_demi">Voulez-vous supprimer la session ?</h4>
          <p class="text-secondary-color">Cette action ne sera pas modifiable.</p>
        </div>
        <div class="flex justify-center gap-[16px]">
          <AppButton type="outlined" label="Annuler" class="w-full" @click="cancel" />
          <AppButton label="Supprimer" class="w-full" variant="error" @click="confirm" />
        </div>
      </div>
    </template>
  </CenterModal>
</template>

<style scoped lang="scss"></style>
